import $ from 'jquery';
import { Ajaxinate } from 'ajaxinate'; // Used on Collections for Infinite Scroll & Load More

// Note:  This function is overriding the version in the npm package, because
//        that version breaks in the Theme editor.
//        Github issue reference: https://github.com/Elkfox/Ajaxinate/issues/26
Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    var parser = new DOMParser();
    var htmlDoc = parser.parseFromString(this.request.responseText, "text/html");
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = htmlDoc.querySelectorAll(this.settings.container)[0];
      var newPagination = htmlDoc.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.overrideMimeType("text/html");
  this.request.send();
};

import Section from '../Section';

// FIXME: make all the jquery relative to `this.element`

export default class Collection extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.loadTagFilter();
    this.loadSort();
    this.colorSwatchCheck();
    this.loadPaging();
    document.addEventListener('paginate', this.loadPaging);
  }

  colorSwatchCheck = () => {

    // Check whether each color in a swatch for a product in the grid is fully sold out.
    // Only mark a color as crossed out if that color is sold out over ALL variants.
    $('.indiv-product__swatches.colour label, .indiv-product__swatches.color label').each(function (index, label) {
      const labelFor = $(label).attr('for');
      const thisInputVal = $('#' + labelFor).val();

      const productJson = $(label).closest('.indiv-product').find('.product-grid-json').get(0);
      if (!productJson) return;

      const productJsonData = JSON.parse(productJson.textContent);

      var matchingVariants = productJsonData.variants.filter((variant) => {
        // If the variant option uses this label value, and the variant is available for sale.
        if (variant.options.indexOf(thisInputVal) > -1 && variant.available == true) return true;
        return false;
      });

      if (matchingVariants.length === 0) {
        $(label).addClass('soldout');
      }
    });
  }

  loadPaging = () => {
    if ($('#AjaxinateInfiniteScrolling').length) {
      new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinateInfiniteScrolling',
        method: 'scroll',
        loadingText: 'Loading',
        offset: 500,
      });
    }

    if ($('#AjaxinateLoadMore').length) {
      new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinateLoadMore',
        method: 'click',
        loadingText: 'Loading',
      });
    }
  }

  loadTagFilter = () => {
    /* Product Tag Filters - Good for any number of filters on any type of collection pages */
    var collFilters = $('.coll-filter');
    collFilters.on('change', function () {
      var newTags = [];
      collFilters.each(function () {
        var val = $(this).val();
        if (val) {
          newTags.push(val);
        }
      });
      if (newTags.length) {
        var query = newTags.join('+');
        window.location.href = $('#link-to-tag-generic a').attr('href').replace(/\/tag($|\?)/, '/' + query + '$1');
      } else {
        window.location.href = $('#link-to-collection').val().toString();
      }
    });
  }

  loadSort = () => {
    const queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    var sort_by = $('#collection-sort-by').val();
    $('#sort-by')
      .val(sort_by)
      .on('change', function () {
        queryParams.sort_by = $(this).val();
        location.search = $.param(queryParams).replace(/\+/g, '%20');
      });
  }
}
